import styled from 'styled-components';
import { Wrap } from '../../../../assets/styledAssets/grid';
export const SectionWrap = styled(Wrap)`
  width: 100%;
  .actions {
    display: none;
  }
  &:hover {
    .actions {
      display: flex;
    }
  }
`;
